import { Col, Menu, Row, Space } from "antd";
import { BranchesOutlined, CloudOutlined, SlackOutlined, ApartmentOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useOutletContext } from "react-router";
import { IProjectDetails } from "../../types";

export default function ProjectAdminRoot() {
    const navigate = useNavigate();
    const location = useLocation();
    const { projectDetails } = useOutletContext<{ projectDetails: IProjectDetails }>();
    const [activeTab, setActiveTab] = useState("git");

    useEffect(() => {
        setActiveTab(location.pathname.split("/")[4] || "git");
    }, [location.pathname]);

    return (
        <Row gutter={24}>
            <Col span={6}>
                <Menu
                    mode="inline"
                    className="ant-card-bordered"
                    selectedKeys={[activeTab]}
                    onSelect={(item) => {
                        navigate(item.key);
                        setActiveTab(item.key);
                    }}
                    openKeys={["integrations"]}
                    items={[
                        {
                            key: "integrations",
                            label: "Integrations",
                            children: [
                                {
                                    key: "git",
                                    label: <Space>
                                        <BranchesOutlined />
                                        Git
                                    </Space>
                                },
                                {
                                    key: "cloud",
                                    label: <Space>
                                        <CloudOutlined />
                                        Cloud Accounts
                                    </Space>
                                },
                                {
                                    key: "container",
                                    label: <Space>
                                        <ApartmentOutlined />
                                        Container Registries
                                    </Space>
                                },
                                {
                                    key: "slack",
                                    label: <Space>
                                        <SlackOutlined />
                                        Slack
                                    </Space>
                                }
                            ]
                        }
                    ]}
                />
            </Col>
            <Col span={18}>
                <Outlet context={{ projectDetails }} />
            </Col>
        </Row >
    )
}